<template>
  <div>
    <label class="typo__label">{{ label }}</label>
    <multiselect
      v-model="playerSelected"
      select-label=""
      deselect-label=""
      track-by="playerId"
      label="name"
      :preselect-first="true"
      :options="players"
      :searchable="false"
      :show-labels="false"
      :allow-empty="false">
      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
    </multiselect>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  name: 'PlayerSelect',
  components: {
    Multiselect
  },
  props: ['value', 'options', 'label'],
  data () {
    return {
      players: this.options,
      player_selected: this.value
    }
  },
  watch: {
    options: function (val) {
      this.players = val
      if (this.$route.query.EntityId) {
        this.players.forEach((player) => {
          if (this.$route.query.EntityId === player.playerId) {
            this.playerSelected = player
          }
        })
      } else {
        this.playerSelected = val[0]
      }
    },
    value: function (val) {
      this.playerSelected = val
    }
  },
  computed: {
    playerSelected: {
      get () {
        return this.player_selected
      },
      set (value) {
        this.player_selected = value
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getPlayersForTeam (callbacks) {
      callbacks = callbacks || [function () {}]
      var params = {}
      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$teamIdParam] = this.team_selected.id
      axios.get(process.env.API_BASE_URL + 'get-team-players-for-season', {params: params})
        .then((response) => {
          this.player_ids = Object.keys(response.data.players)
          this.players = []
          this.player_selected = undefined
          this.player_ids.forEach((playerId) => {
            this.players.push({'playerId': playerId, 'name': response.data.players[playerId]})
          })
          callbacks.forEach((callback) => {
            callback()
          })
        }, (error) => {
          this.loading = false
          this.error = error
        })
    },
    setPlayerSelected () {
      this.player_selected = undefined
      this.players.forEach((player) => {
        if (player.playerId === this.$route.query.PlayerId) {
          this.player_selected = player
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/PlayerSelect.vue